import * as React from 'react';
import './calendar-add-event.scss';
import { useNavigate } from 'react-router-dom';
import PlainNavbar from '../../plainNavbar/plainNavbar';
import TextInput from '../../../common/text-input/text-input';
import CalendarInput from '../../../common/calendar-input/calendar-input';
import TimeInput from '../../../common/time-input/time-input';
import CompleteAddEventModal from '../complete-add-event-modal/complete-add-event-modal';
import CalendarEvents from '../calendar-events.json';
import { useParams } from 'react-router-dom';
import DateSelector from '../../../common/date-selector/date-selector';

const CalendarAddEvent: React.FC = () => {
  const navigate = useNavigate();
  const [currentEvent, setCurrentEvent] = React.useState<any>({
    title: '',
    startDate: '',
    startTime: '',
    endDate: '',
    endTime: '',
  });
  const [completeModal, setCompleteModal] = React.useState<boolean>(false);

  const { id } = useParams();

  React.useEffect(() => {
    if (id) {
      const currentEvent = CalendarEvents.find((e: any) => {
        return e.id.toString() === id;
      });
      setCurrentEvent(currentEvent);
    }
  }, [CalendarEvents]);

  const handleForm = (data: any, option: string) => {
    if (option === 'START_DATE') {
      setCurrentEvent((values: any) => ({ ...values, startDate: data }));
    }
    if (option === 'END_DATE') {
      setCurrentEvent((values: any) => ({ ...values, endDate: data }));
    }
    if (option === 'START_TIME') {
      setCurrentEvent((values: any) => ({ ...values, startTime: data.target.value }));
    }
    if (option === 'END_TIME') {
      setCurrentEvent((values: any) => ({ ...values, endTime: data.target.value }));
    }
  };

  const saveNewEvent = () => {
    const newEvents = [...CalendarEvents, event];
    // Update the event database
    setCompleteModal(!completeModal);
  };

  const updateEvent = () => {
    // Update the event database
    setCompleteModal(!completeModal);
  };

  return (
    <>
      <PlainNavbar save={saveNewEvent} backgroundColor="#f3f4f6" route="calendar">
        <div className="calendar-add-event">
          <div className="calendar-add-event__head">
            <div className="calendar-add-event__head__text">캘린더 추가</div>
            <div className="calendar-add-event__head__subtext">캘린더 정보를 입력해주세요</div>
          </div>
          <div className="calendar-add-event__card">
            <div className="calendar-add-event__card__left">
              <div className="calendar-add-event__card__head">
                <div>기본 정보</div>
              </div>
              <div className="calendar-add-event__body">
                <div className="calendar-add-event__body__title">
                  <TextInput
                    inputData={handleForm}
                    inputName="title"
                    label="타이틀"
                    placeholder="템플릿명 입력"
                    value={currentEvent.title}
                  />
                </div>
                <div className="calendar-add-event__body__date">
                  <div className="calendar-add-event__body__date__left">
                    <div className="calendar-add-event__body__date__left__left">
                      {/* <DateSelector
                                            inputData={(date: any) => handleForm(date, 'START_DATE')}
                                            label="시작일"
                                            defaultValue={currentEvent.startDate}
                                            placeholder="시작일 선택"
                                            height={56}
                                        /> */}
                    </div>
                    <div className="calendar-add-event__body__date__left__right">
                      <TimeInput
                        inputName="startTime"
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleForm(event, 'START_TIME')}
                        value={currentEvent.startTime}
                        iconSide="RIGHT"
                      />
                    </div>
                  </div>
                  <div className="calendar-add-event__body__date__right">
                    <div className="calendar-add-event__body__date__left__left">
                      {/* <DateSelector
                                            inputData={(date: any) => handleForm(date, 'END_DATE')}
                                            label="종료일"
                                            defaultValue={currentEvent.endDate}
                                            placeholder="종료일 선택"
                                            height={56}
                                        /> */}
                    </div>
                    <div className="calendar-add-event__body__date__left__right">
                      <TimeInput
                        inputName="endTime"
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleForm(event, 'END_TIME')}
                        value={currentEvent.endTime}
                        iconSide="RIGHT"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="calendar-add-event__card__right">
              <div>
                <div className="calendar-add-event__right-heads">캘린더 시작~종료일</div>
                <div className="calendar-add-event__right-body">시작일~종료일까지 캘린더에 일정이 표시됩니다.</div>
              </div>
            </div>
          </div>
        </div>
        {completeModal && <CompleteAddEventModal onClose={saveNewEvent} />}
      </PlainNavbar>
    </>
  );
};
export default CalendarAddEvent;
